export default "__VITE_ASSET__9Njklr6J__"